import React, { useState } from 'react';
import { Table, Button } from '@mantine/core';
import { format } from 'date-fns';
import {ReactComponent as DetailIcon } from '../../assets/icons/Detail.svg'
import TableMedusa from '../../components/Table';
import { RecipesListProps } from '../../types/recipes';
import { useNavigate } from 'react-router-dom';


const RecipesList = ({data}: RecipesListProps)=>{
    const icon = <DetailIcon width={19} height={19}></DetailIcon>;
    const navigate = useNavigate();

    const onClickDetail = (recipeID:number)=>{
      navigate(`/recipes/${recipeID}`);
    }


    const rows = data?.map(({ id, name, num_hoppers, sorter_color_model_id, sorter_recycling_model_id, sorter_reuse_model_id, updated_at}) => (
             <Table.Tr key={id}>
                  <Table.Td>{id}</Table.Td>
                  <Table.Td>{num_hoppers}</Table.Td>
                  <Table.Td>{name}</Table.Td>
                  <Table.Td>{format(new Date(updated_at), 'dd/MM/yyyy')}</Table.Td>
                  <Table.Td>
                      <Button variant="transparent" onClick={()=>onClickDetail(id)}>{icon}</Button>
                  </Table.Td>
            
                </Table.Tr>

    ));



    return(
        <div>
           <TableMedusa headers={["ID", "Number Hoppers", "Name", "Updated at"]} rows={rows}></TableMedusa>
        </div>
    );
}

export default RecipesList